import { useState } from 'react';
import { IconMaximize, IconTimeline, IconUserPlus } from '@tabler/icons-react';
import { useT } from '@hana/i18n';
import { useToast } from '@hana/ui';
import './i18n';
import { PPOOL_SALE, TEAM_SALE, type PTone } from './team';
import s from './home.module.css';
import tc from './team.module.css';

// Mint-Home (1536) · N-04f: khối Việc của team · theo người (vai sale), cap 4 hàng; bấm hàng → 3 việc của người đó.
const DUE: Record<PTone, string | undefined> = { tx: undefined, warn: tc.dwarn, err: tc.derr };
const CODE_CLS = (c: string): string | undefined => (c === 'PRC' || c === 'DCF' ? s.p : undefined);

export function Team({ empty }: { empty: boolean }) {
  const t = useT();
  const toast = useToast();
  const tip = (m: string) => toast({ msg: m });
  const [pick, setPick] = useState<string | null>(null);
  const [re, setRe] = useState<Record<string, true>>({});
  const [un, setUn] = useState<Record<string, true>>({});
  const all = empty ? [] : TEAM_SALE;
  const rows = all.slice(0, 4);
  const mx = Math.max(1, ...all.map((p) => p.open));
  const overN = all.reduce((a, p) => a + p.over, 0);
  const pi = all.findIndex((p) => p.k === pick);
  const tasks = pi < 0 ? [] : [0, 1, 2].map((j) => ({ key: `${pick}:${j}`, r: PPOOL_SALE[(pi * 2 + j) % PPOOL_SALE.length]! }));
  return (
    <section className={s.my} aria-label={t('hn.tm.aria')}>
      <div className={s.myH}>
        <h2>{t('hn.tm.title')}</h2><span className={s.sum}>{t('hn.tm.sum', { n: all.length, o: overN })}</span>
        <span className={s.grow} />
        <span className={tc.leg}><span><i className={tc.ok} />{t('hn.tm.ok')}</span><span><i className={tc.er} />{t('hn.tm.over')}</span><span><i className={tc.wt} />{t('hn.tm.wait')}</span></span>
        <button type="button" className={s.ib} aria-label={t('hn.tm.expandL')} title={t('hn.tm.expand')} onClick={() => tip(t('home.later'))}><IconMaximize size={15} stroke={2} aria-hidden="true" /></button>
      </div>
      {!all.length ? <div className={s.none}>{t('hn.tm.none')}</div> : (
        <div role="img" aria-label={`Việc mở theo người: ${all.map((p) => `${p.k} ${p.open} mở, ${p.over} quá hạn, ${p.wait} chờ`).join('; ')}`} className={tc.list}>
          {rows.map((p) => {
            const gated = p.gate > 0 && !un[p.k];
            return (
              <div key={p.k} className={`${tc.row} ${pick === p.k ? tc.on : ''}`} onClick={() => setPick(pick === p.k ? null : p.k)}>
                <div className={tc.who}><div className={tc.nm}>{p.k}</div><div className={tc.seat}>{p.seat}</div></div>
                <div className={tc.barw}><div className={tc.bar} style={{ width: `${Math.round((p.open / mx) * 100)}%` }}><i className={tc.ok} style={{ flex: `${Math.max(0, p.open - p.over - p.wait)} 1 0` }} /><i className={tc.er} style={{ flex: `${p.over} 1 0` }} /><i className={tc.wt} style={{ flex: `${p.wait} 1 0` }} /></div></div>
                <span className={tc.cnt}><b>{p.open}</b> {t('hn.tm.openL')} · <b className={p.over ? tc.derr : undefined}>{p.over}</b> {t('hn.tm.late')}</span>
                <div className={tc.act}>
                  {gated
                    ? <button type="button" className={`${s.bt} ${p.gate === 2 ? tc.gErr : tc.gWarn}`} title={t('hn.tm.unTip')} onClick={(e) => { e.stopPropagation(); setUn((u) => ({ ...u, [p.k]: true })); tip(t('hn.tm.unDone')); }}><IconTimeline size={16} stroke={1.8} aria-hidden="true" />{p.gate === 2 ? t('hn.tm.un2') : t('hn.tm.unWarn')}</button>
                    : <span className={tc.free}>{un[p.k] ? t('hn.tm.unDid') : t('hn.tm.free')}</span>}
                </div>
              </div>
            );
          })}
        </div>
      )}
      {pi >= 0 && (
        <div className={tc.pp}>
          <div className={tc.ppH}><b>{t('hn.tm.of', { p: pick ?? '' })}</b><button type="button" className={s.ib} aria-label={t('hn.tm.closeL')} onClick={() => setPick(null)}>×</button></div>
          {tasks.map(({ key, r }) => (
            <div key={key} className={tc.pr}>
              <span className={`${s.code} ${CODE_CLS(r[0])}`}>{r[0]}</span>
              <div className={s.rb}><div className={s.rt}>{r[1]}</div><div className={s.rs}>{r[2]}<span className={`${tc.due} ${DUE[r[4]]}`}>{r[3]}</span></div></div>
              {re[key] ? <span className={tc.rd}>{t('hn.tm.reDone')}</span> : <button type="button" className={s.bt} onClick={() => { setRe((x) => ({ ...x, [key]: true })); tip(t('hn.tm.reTip')); }}><IconUserPlus size={16} stroke={1.8} aria-hidden="true" />{t('hn.tm.re')}</button>}
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
